"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppContainer = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _CalculatorContainer = require("../CalculatorContainer");
var _context = require("../../context");
var _uiKit = require("@cian/ui-kit");
var _getRegionId = require("./utils/getRegionId");
var _constants = require("../../constants");
const _excluded = ["regionId", "startPrice", "withEscrow", "title", "subtitle", "priceTooltipTitle", "priceTooltipText", "escrowTooltipTitle", "escrowTooltipText"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const AppContainer = _ref => {
  let {
      regionId = _constants.DEFAULT_REGION_ID,
      startPrice = _constants.DEFAULT_PRICE,
      withEscrow = _constants.DEFAULT_WITH_ESCROW,
      title = _constants.DEFAULT_TITLE,
      subtitle = _constants.DEFAULT_SUBTITLE,
      priceTooltipTitle = _constants.DEFAULT_PRICE_TOOLTIP_TITLE,
      priceTooltipText = _constants.DEFAULT_PRICE_TOOLTIP_TEXT,
      escrowTooltipTitle = _constants.DEFAULT_ESCROW_TOOLTIP_TITLE,
      escrowTooltipText = _constants.DEFAULT_ESCROW_TOOLTIP_TEXT
    } = _ref,
    restProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const context = React.useMemo(() => _objectSpread({
    region: (0, _getRegionId.getRegionById)(regionId),
    startPrice,
    withEscrow,
    title,
    subtitle,
    priceTooltipTitle,
    priceTooltipText,
    escrowTooltipTitle,
    escrowTooltipText
  }, restProps), [escrowTooltipText, escrowTooltipTitle, priceTooltipText, priceTooltipTitle, regionId, restProps, startPrice, subtitle, title, withEscrow]);
  return /*#__PURE__*/React.createElement(_context.AppContext.Provider, {
    value: context
  }, /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    desktop: true
  }, /*#__PURE__*/React.createElement(_CalculatorContainer.CalculatorContainer, null)), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    tablet: true,
    phone: true
  }, /*#__PURE__*/React.createElement(_CalculatorContainer.CalculatorContainerMobile, null)));
};
exports.AppContainer = AppContainer;